import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { CircularProgress } from '@material-ui/core';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
const API = process.env.REACT_APP_API_END_POINT;
function SignIn({ onAuthSuccess }) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [busy, setBusy] = useState(false)
  const classes = useStyles();
  const onChange = e => {
    switch (e.target.id) {
      case "email": return setEmail(e.target.value)
      case "password": return setPassword(e.target.value)
    }
  }
  const authenticate = (e) => {
    //
    e.preventDefault();
    setBusy(true)
    let formBody = [];
    formBody.push(encodeURIComponent('email') + "=" + encodeURIComponent(email));
    formBody.push(encodeURIComponent('password') + "=" + encodeURIComponent(password));
    fetch(`${API}/authenticate`, {
      method: 'POST',
      body: formBody.join("&"),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;'
      },
    })
      .then(response => {
        setBusy(false)
        if (response.status >= 400 && response.status < 600) {
          throw new Error(response);
        }
        onAuthSuccess()
      })
      .catch(error => console.log(error.message))
    console.log('hello', email, password)
    return false
  }
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form onSubmit={authenticate} className={classes.form} noValidate>
          <TextField
            onChange={onChange}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoFocus
          />
          <TextField
            onChange={onChange}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
          />
          {busy ?
            <CircularProgress /> : <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign In
          </Button>
          }
        </form>
      </div>
    </Container>
  );
}

export default SignIn